import { type ValidatorAdapter } from '@tanstack/react-router';
import { type ZodType } from 'zod';

type In<TSchema> = TSchema extends ZodType<any, infer Input> ? Input : never;

type Out<TSchema> = TSchema extends ZodType<infer Output, any> ? Output : never;

export default function createValidateSearch<TSchema extends ZodType<any>>(
    schema: TSchema,
): ValidatorAdapter<In<TSchema>, Out<TSchema>> {
    const validateSearch: ValidatorAdapter<In<TSchema>, Out<TSchema>> = {
        types: {
            input: {},
            output: {},
        } as any,
        parse(input: any): any {
            return schema.parse(input);
        },
    };

    return validateSearch;
}
